import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import type { AlertProps, SnackbarProps as MuiSnackbarProps } from '@mui/material';
import { Alert, IconButton, Snackbar as MuiSnackbar } from '@mui/material';
import type { FC } from 'react';

const ANCHOR_ORIGN: MuiSnackbarProps['anchorOrigin'] = { vertical: 'bottom', horizontal: 'center' };

export type SnackbarProps = Pick<MuiSnackbarProps, 'autoHideDuration' | 'message' | 'onClose' | 'open'> & {
  severity?: AlertProps['severity'];
};

/**
 * Displays a floating notification with icon, message, and close button. You can change the color based on the severity.
 */
export const Snackbar: FC<SnackbarProps> = ({
  autoHideDuration = 5000,
  message,
  onClose,
  open,
  severity = 'info',
  ...props
}) => {
  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClose && onClose(e, 'clickaway');
  };

  const action = (
    <IconButton
      aria-label="Close notification"
      data-sp-button-label="Close notification"
      color="inherit"
      onClick={handleClose}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <MuiSnackbar
      action={action}
      anchorOrigin={ANCHOR_ORIGN}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      open={open}
      {...props}
    >
      <Alert action={action} iconMapping={{ success: <CheckCircleIcon /> }} severity={severity} variant="standard">
        {message}
      </Alert>
    </MuiSnackbar>
  );
};
